import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import { verticalTypeMapping } from "@dealer-center/ddc-pages-account-search-interface";
import { PagesClientSearchSearchPills } from "./SearchPills";
import {
  itemIsComplexMatchSpecDealerCodeSpec,
  itemIsComplexMatchSpecString,
  itemIsDateRange,
  mapping
} from "./types";
import { StyledPagesClientSearchSearchPillsArea } from "./styles";
import { AccountSearchContext } from "@dealer-center/ddc-pages-account-search-context";
import { useContext } from "react";

export const PagesClientSearchSearchPillsArea = () => {
  const { searchRequest, updateSearchRequest: setSearchRequest } =
    useContext(AccountSearchContext);

  const onClick = (
    value: string | number,
    keyOfItemToAdjust: keyof dealerSearchIncoming
  ) => {
    const searchRequestItemToAdjust = searchRequest[keyOfItemToAdjust];
    if (!searchRequestItemToAdjust) return;

    if (Array.isArray(searchRequestItemToAdjust)) {
      const actualValue =
        keyOfItemToAdjust !== "verticalTypes"
          ? value
          : findVerticalTypeValue(value);
      const newFilteredItems = searchRequestItemToAdjust.filter(
        item => item !== actualValue
      );
      const newSearchRequest = {
        ...searchRequest,
        [keyOfItemToAdjust]: newFilteredItems
      };
      setSearchRequest(newSearchRequest);
    } else if (itemIsDateRange(searchRequestItemToAdjust)) {
      const newSearchRequest = {
        ...searchRequest,
        [keyOfItemToAdjust]: undefined
      };
      setSearchRequest(newSearchRequest);
    } else if (itemIsComplexMatchSpecString(searchRequestItemToAdjust)) {
      const newSearchRequest = {
        ...searchRequest,
        [keyOfItemToAdjust]: {
          ...searchRequestItemToAdjust,
          matchAny: searchRequestItemToAdjust.matchAny?.filter(
            item => item !== value
          ),
          matchAll: searchRequestItemToAdjust.matchAll?.filter(
            item => item !== value
          ),
          matchNone: searchRequestItemToAdjust.matchNone?.filter(
            item => item !== value
          )
        }
      };
      setSearchRequest(newSearchRequest);
    } else if (
      itemIsComplexMatchSpecDealerCodeSpec(searchRequestItemToAdjust)
    ) {
      const newSearchRequest = {
        ...searchRequest,
        [keyOfItemToAdjust]: {
          ...searchRequestItemToAdjust,
          matchAll: searchRequestItemToAdjust.matchAll?.filter(
            item => item.type !== value
          )
        }
      };
      setSearchRequest(newSearchRequest);
    }
  };
  return (
    <StyledPagesClientSearchSearchPillsArea data-testid="search-pills-area">
      {mapping.map(({ key, label }) => {
        const items =
          key !== "verticalTypes"
            ? searchRequest[key]
            : searchRequest[key]?.map(findVerticalTypeLabel);
        return (
          <PagesClientSearchSearchPills
            items={items}
            key={key}
            label={label}
            mappingKey={key}
            onClick={onClick}
          />
        );
      })}
    </StyledPagesClientSearchSearchPillsArea>
  );
};
function findVerticalTypeLabel(item: string) {
  return verticalTypeMapping.find(({ value }) => value === item)?.label || item;
}

function findVerticalTypeValue(item: string | number) {
  return verticalTypeMapping.find(({ label }) => label === item)?.value || item;
}
